import { CraigslistAdState } from './craigslist-ad-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, StateStatus, updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: CraigslistAdState = {
  craigslistAdsById: {},
  craigslistAdsStateByJobBoostId: {},
  craigslistAreasById: {},
  craigslistAreasState: StateStatus.notAttempted,
  craigslistSubareasById: {},
  craigslistSubareasState: StateStatus.notAttempted,
};

export const craigslistAdReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_CRAIGSLIST_ADS'): {
      const { jobBoostIds } = action.payload.args;

      let newState = { ...state };
      jobBoostIds.forEach((jobBoostId: string) => {
        newState = updateResourceByParam(newState, 'craigslistAds', 'jobBoostId', jobBoostId, true);
      });

      return newState;
    }
    case SUCCESS('LOAD_CRAIGSLIST_ADS'): {
      const {
        args: { jobBoostIds },
        data,
      } = action.payload;
      const craigslistAdData = convertArrayToMap(data, (d: CraigslistAd) => String(d.postingId));

      let newState = { ...state };
      jobBoostIds.forEach((jobBoostId: string) => {
        newState = updateResourceByParam(
          newState,
          'craigslistAds',
          'jobBoostId',
          jobBoostId,
          false,
          craigslistAdData,
        );
      });

      return newState;
    }
    case FAILURE('LOAD_CRAIGSLIST_ADS'): {
      const { jobBoostIds } = action.payload.args;

      let newState = { ...state };
      jobBoostIds.forEach((jobBoostId: string) => {
        newState = updateResourceByParam(
          newState,
          'craigslistAds',
          'jobBoostId',
          jobBoostId,
          false,
        );
      });

      return newState;
    }
    case SUCCESS('LINK_CRAIGSLIST_AD'): {
      const { craigslistAd } = action.payload.data;

      const newState = { ...state };
      newState.craigslistAdsById = {
        ...newState.craigslistAdsById,
        [craigslistAd.postingId]: craigslistAd,
      };

      return newState;
    }
    case STARTING('LOAD_CRAIGSLIST_AREAS'): {
      return { ...state, craigslistAreasState: StateStatus.loading };
    }
    case SUCCESS('LOAD_CRAIGSLIST_AREAS'): {
      const { data } = action.payload;
      return {
        ...state,
        craigslistAreasById: convertArrayToMap(data, (area: CraigslistArea) =>
          String(area.craigslistAreaId),
        ),
        craigslistAreasState: StateStatus.success,
      };
    }
    case FAILURE('LOAD_CRAIGSLIST_AREAS'): {
      return { ...state, craigslistAreasState: StateStatus.error };
    }
    case STARTING('LOAD_CRAIGSLIST_SUBAREAS'): {
      return { ...state, craigslistSubareasState: StateStatus.loading };
    }
    case SUCCESS('LOAD_CRAIGSLIST_SUBAREAS'): {
      const { data } = action.payload;
      return {
        ...state,
        craigslistSubareasById: convertArrayToMap(data, (subarea: CraigslistSubarea) =>
          String(subarea.craigslistSubareaId),
        ),
        craigslistSubareasState: StateStatus.success,
      };
    }
    case FAILURE('LOAD_CRAIGSLIST_SUBAREAS'): {
      return { ...state, craigslistSubareasState: StateStatus.error };
    }
    default: {
      return state;
    }
  }
};
